"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Document = void 0;
var create_entity_1 = require("../../utils/create-entity");
var client_1 = require("@apollo/client");
var components_1 = require("../../components");
exports.Document = {
  name: 'Document',
  label: 'Document',
  autoRoutes: ['list', 'details', 'create', 'update'],
  usePublishStatus: true,
  usePermissions: true,
  useSlices: true,
  useConnections: true,
  components: {
    details: components_1.DocumentDetailsLayout
  },
  table: {
    fieldNames: ["entityValue", "createdBy", "type", "description"]
  },
  banner: {},
  pluralLabel: 'Documents',
  filters: {
    fields: {
      type: {
        entityTypeName: 'DocumentType'
      },
      folder: {
        entityTypeName: 'Folder'
      }
    }
  },
  details: {
    queryFields: "\n      content { id text html }\n      description { id text html }\n      owner { id }\n      folder { id }\n    "
  },
  list: {
    resultsVariant: 'table'
  },
  form: {
    paginate: true,
    modal: {
      fill: true
    },
    query: (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query DocumentFormQuery {\n        documentTypes: allDocumentTypes { id name slug }\n        people: allPeople { id name slug }\n        folders: allFolders { id name slug }\n      }\n    "], ["\n      query DocumentFormQuery {\n        documentTypes: allDocumentTypes { id name slug }\n        people: allPeople { id name slug }\n        folders: allFolders { id name slug }\n      }\n    "]))),
    fieldSets: [{
      label: 'Name & Content',
      name: 'overview'
    }, {
      label: 'Properties',
      name: 'properties'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      content: {
        type: 'content'
      },
      type: {
        type: 'linked',
        entityTypeName: 'DocumentType',
        fieldSet: 'properties',
        description: 'What type of {{DOCUMENT}} is this?'
      },
      owner: {
        type: 'linked',
        entityTypeName: 'Person',
        fieldSet: 'properties'
      },
      folder: {
        type: 'linked',
        entityTypeName: 'Folder',
        fieldSet: 'properties',
        description: 'Specify a {{FOLDER}} to file this {{DOCUMENT}} under'
      },
      description: {
        type: 'description',
        fieldSet: 'properties',
        height: '100px'
      }
    })
  }
};
var templateObject_1;